import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../assets/delete.svg'


const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-gray-400",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "absolute right-8 sm:right-14 mt-2 w-52 rounded-xl shadow-xl text-sm overflow-hidden z-20"
}
const _hoisted_5 = {
  class: "rounded-md bg-white shadow-xs w-full px-2 py-1",
  role: "menu",
  "aria-orientation": "vertical",
  "aria-labelledby": "options-menu"
}
const _hoisted_6 = { class: "flex flex-col my-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold ml-4 text-xs" }, "Remove member")
], -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      disabled: _ctx.isSuperAdmin,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMenuOpen = !_ctx.isMenuOpen)),
      type: "button",
      class: "select-none px-2 hover:bg-gray-100 rounded"
    }, _hoisted_3, 8, _hoisted_1),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-200",
      "enter-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isMenuOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteMember && _ctx.deleteMember(...args))),
                    class: "rounded p-4 hover:bg-background"
                  }, _hoisted_8)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512)), [
    [_directive_click_away, _ctx.closeMenu]
  ])
}